export enum InteractionName {
  LAZY_COMPONENT_LOAD = 'lazy-component-load',
  WIDGET_LOAD = 'widget-load-common',
  WIDGET_LOAD_BY = 'widget-load-by',
  WIDGET_RENDER = 'widget-render',
  UPDATE_COUNTRY = 'update-country',

  ALE = 'load',
  ALE_MOUNT = 'load-phase-loader',
  ALE_RENDER = 'load-phase-render',
  ALE_FULL_RENDER = 'load-phase-full-render',
  ALE_FULL_RENDER_BY = 'load-phase-full-render-by',

  FRAMED_MODAL_ALE = 'framed-modal-load',
  FRAMED_MODAL_ALE_LOADER = 'framed-modal-load-phase-loader',
  FRAMED_MODAL_ALE_RENDER = 'framed-modal-load-phase-render',

  PAY_MODAL_ALE = 'pay-modal-load',
  SQUARE_3DS_MODAL_MOUNT = 'square-3ds-modal-mount',
  INSTANT_PAYMENT_MODAL_MOUNT = 'instant-modal-modal-mount',

  INIT_SDK = 'init-sdk',
  LOAD_SETTINGS = 'load-settings',
  LOAD_SAVED_CC = 'load-saved-cc',
}
